function TeamCard({ image, name, title, quote }) {
  return (
    <div className="bg-white shadow-lg rounded-lg overflow-hidden text-center relative">

      {/* Blue Top Section */}
      <div className="bg-brand h-24"></div>

      {/* Profile Image */}
      <div className="flex justify-center -mt-12">
        <div className="bg-white p-1 rounded-full shadow">
          <img
            src={image}
            alt={name}
            className="w-24 h-24 rounded-full object-cover"
          />
        </div>
      </div>

      {/* Card Content */}
      <div className="p-6">
        <h3 className="text-lg font-semibold">{name}</h3>
        <p className="text-sm text-gray-500 mb-3">{title}</p>
        <p className="text-gray-600 italic text-sm">"{quote}"</p>
      </div>

    </div>
  );
}

export default TeamCard;